import React from 'react';
import ReactDom from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { reducer as form } from 'redux-form';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';
import {
    syncHistoryWithStore,
    routerReducer as routing
} from 'react-router-redux';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import registerServiceWorker from './registerServiceWorker';
// Import your reducers and routes here
import Current from './components/song/Current';
import Leader from './components/song/Leader';

import song from './reducers/song/';
import songRoutes from './routes/song';

const store = createStore(
    combineReducers({ routing, form, song }),
    applyMiddleware(thunk)
);

const history = syncHistoryWithStore(createBrowserHistory(), store);

ReactDom.render(
    <Provider store={store}>
        <Router history={history}>
            <Switch>
                <Route
                    path="/"
                    component={Current}
                    strict={true}
                    exact={true}
                />
                <Route
                    path="/leader"
                    component={Leader}
                    strict={true}
                    exact={true}
                />
                {songRoutes}
                <Route render={() => <h1>Not Found</h1>} />
            </Switch>
        </Router>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js